import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { Currency } from '../currency';
import { HttpService } from '../service/http.service';
import { SalesProductType } from '../sales-product-type';
import { ToastMessageService } from '../toast-message.service';
import Decimal from 'decimal.js';
import { SalesProduct } from '../sales-product';
import { map } from 'rxjs/operators';
import { ExchangeRate } from '../exchange-rate';
import { Moment } from 'moment';
import { CKEDITORCONFIGMINIMAL, CKEDITORCONFIGMINIMALWITHLINK } from '../ckeditor-config';
import { ContactRequestQuotationWithDetail } from '../contact-request-quotation-with-detail';
import { ContactRequestQuotation } from '../contact-request-quotation';
import { ContactRequestService } from '../service/contact-request.service';
import { QuotationTemplateService } from '../quotation-template.service';
import { QuotationTemplate } from '../quotation-template';
import * as Editor from '../../libs/ckeditor';

@Component({
  selector: 'app-clone-contact-request-quotation',
  templateUrl: './clone-contact-request-quotation.component.html',
  styleUrls: ['./clone-contact-request-quotation.component.css']
})
export class CloneContactRequestQuotationComponent implements OnInit {

  @Input("selectedQuotation")
  selectedQuotation!: ContactRequestQuotationWithDetail;

  @Input("requestId")
  requestId!: number

  @Output()
  finishCloneEvent: EventEmitter<void> = new EventEmitter();

  quotationForm!: FormGroup;
  productTypes: SalesProductType[] = [];
  currencies: Currency[] = [];
  productPriceInCurrency: string[] = [];
  productPriceInSecondCurrency: string[] = [];
  yearRange = "";

  totalPriceInCurrency: Decimal = new Decimal(0.00);
  totalPriceInSecondCurrency: Decimal = new Decimal(0.00);

  editorConfig = CKEDITORCONFIGMINIMAL;
  descriptionEditorConfig = CKEDITORCONFIGMINIMALWITHLINK;

  selectedTemplateName = null;
  displayTemplateCreatingDialog = false;
  displayTemplateDialog = false;
  templates: QuotationTemplate[] = [];
  selectedTemplate: QuotationTemplate | null = null;
  public Editor = Editor;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    public contactRequestService: ContactRequestService,
    private quotationTemplateService: QuotationTemplateService
  ) { }

  ngOnInit(): void {
    this.yearRange = (moment().year() - 10) + ":" + (moment().year() + 4);
    this.httpService.getCurrencies().subscribe(currencies => {
      this.currencies = currencies;
    });
    this.httpService.getSalesProductTypes().subscribe(res => this.productTypes = res);
    this.quotationForm = this.builder.group({
      description: this.selectedQuotation.description,
      comment: this.selectedQuotation.comment,
      products: this.builder.array([]),
      baseCurrency: this.selectedQuotation.baseCurrency,
      secondCurrency: this.selectedQuotation.secondCurrency,
      quotationDate: moment().toDate(),
      dueDate: null,
      deposit: new Decimal(250.00),
      priceIncludes: this.selectedQuotation.priceIncludes,
      priceNotIncludes: this.selectedQuotation.priceNotIncludes
    });
    this.initProducts(this.selectedQuotation.productList);
  }


  mouseover(i: number) {
    let array = this.quotationForm.get("products") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(true);
  }
  mouseout(i: number) {
    let array = this.quotationForm.get("products") as FormArray;
    array.controls[i].get("activeMenu")!.setValue(false);
  }

  moveItem(array: any[], i: number, delta: number) {
    let newIndex = i + delta;
    if (newIndex < 0 || newIndex >= array.length) {
      return;
    }
    let indexes = [i, newIndex].sort();
    array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
  }

  moveUp(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    this.moveItem(itemArray.controls, i, -1);
  }

  moveDown(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    this.moveItem(itemArray.controls, i, 1);
  }

  insertAt(array: AbstractControl[], index: number, element: FormGroup) {
    array.splice(index, 0, element);
  }

  insertItem(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    this.insertAt(itemArray.controls, i + 1, this.builder.group({
      type: this.productTypes[0],
      description: "",
      amount: [new Decimal(0.00), Validators.pattern(/^-?[.\d]+$/)],
      currency: new Currency(1, "Euro", "EUR", "€"),
      activeMenu: false
    }));
  }

  removeItem(i: number) {
    let itemArray = this.quotationForm.get("products") as FormArray;
    itemArray.controls.splice(i, 1);
  }

  createQuotation() {
    let quotation = new ContactRequestQuotation(
      this.quotationForm.value.description,
      this.quotationForm.value.comment,
      this.setProductList(),
      this.quotationForm.value.baseCurrency,
      this.quotationForm.value.secondCurrency,
      this.quotationForm.value.quotationDate == null ? null : moment(this.quotationForm.value.quotationDate).utc(true),
      this.quotationForm.value.dueDate == null ? null : moment(this.quotationForm.value.dueDate).utc(true),
      this.quotationForm.value.deposit, 
      this.quotationForm.value.priceIncludes, 
      this.quotationForm.value.priceNotIncludes);
    this.httpService.postContactRequestQuotation(quotation, this.requestId).subscribe(() => {
      this.finishCloneEvent.emit();
    }, error => this.toastService.addError("Error", error.message));
  }

  setProductList() {
    let products = [];
    let productFormArray = this.quotationForm.get("products") as FormArray;
    for (let product of productFormArray.controls) {
      products.push(new SalesProduct(
        product.get("type")!.value,
        product.get("description")!.value,
        new Decimal(product.get("amount")!.value),
        product.get("currency")!.value
      ));
    }
    return products;
  }

  initProducts(productList: SalesProduct[]) {
    let array = this.quotationForm.get("products") as FormArray;

    for (let product of productList) {
      array.controls.push(this.builder.group({
        type: product.productType,
        description: product.description,
        amount: product.amount.toFixed(2),
        currency: product.currency,
        activeMenu: false
      }));
      this.calculatePriceInCurrency(new Decimal(product.amount), product.currency,
        this.quotationForm.get("baseCurrency")!.value).subscribe(amount => {
          this.productPriceInCurrency.push(amount.toFixed(2));
          this.totalPriceInCurrency = this.totalPriceInCurrency.plus(amount.toFixed(2));
        });
      if (this.quotationForm.get("secondCurrency")!.value) {
        this.calculatePriceInCurrency(new Decimal(product.amount), product.currency,
          this.quotationForm.get("secondCurrency")!.value).subscribe(amount => {
            this.productPriceInSecondCurrency.push(amount.toFixed(2));
            this.totalPriceInSecondCurrency = this.totalPriceInSecondCurrency.plus(amount.toFixed(2));
          });
      }
    }
  }
  calculatePriceInCurrency(amount: Decimal, targetCurrency: Currency,
    baseCurrency: Currency): Observable<Decimal> {
    if (targetCurrency.id == baseCurrency.id) {
      return this.getExchangeRateFromEuro(baseCurrency, moment()).pipe(map(rate => {
        return amount;
      }));
    }
    if (targetCurrency.id == 1) {
      return this.getExchangeRateFromEuro(baseCurrency, moment()).pipe(map(rate => {
        return amount.times(rate.exchangeRate);
      }));
    } else if (baseCurrency.id == 1) {
      return this.getExchangeRateFromEuro(targetCurrency, moment()).pipe(map(rate => {
        return amount.times(new Decimal(1).dividedBy(rate.exchangeRate));
      }));
    } else {
      return this.getExchangeRateFromAnotherCurrency(targetCurrency, baseCurrency, moment())
        .pipe(map(rate => {
          return amount.times(rate.exchangeRate);
        }));
    }
  }
  // used to convert euro to another currency
  getExchangeRateFromEuro(currency: Currency, date: Moment): Observable<ExchangeRate> {
    return this.httpService.getExchangeRate(currency, date, true);
  }

  getExchangeRateToEuro(currency: Currency, date: Moment): Observable<ExchangeRate> {
    return this.httpService.getExchangeRateToEuro(currency, date, this.selectedQuotation.baseCurrency, true);
  }

  getExchangeRateFromAnotherCurrency(baseCurrency: Currency, targetCurrency: Currency, date: Moment): Observable<ExchangeRate> {
    return this.httpService.getExchangeRateWithBaseCurrency(baseCurrency, targetCurrency, date, this.selectedQuotation.baseCurrency, true);
  }

  activateTemplateSavingDialog(){
    this.displayTemplateCreatingDialog = true;
  }

  saveQuotationAsTemplate(){
    if(!(this.contactRequestService.contactRequest!.school && this.contactRequestService.contactRequest!.language && this.selectedTemplateName)){
      this.toastService.addError("Error", "School, Template name or Language is missing");
      return;
    }
    this.quotationTemplateService.saveContactRequestQuotationAsTemplate(this.getQuotationFromForm(), this.contactRequestService.contactRequest!.school, 
    this.contactRequestService.contactRequest!.language, this.selectedTemplateName).subscribe(() =>{
      this.toastService.addSuccess("Success", "Template saved");
    }, error => this.toastService.addError("Error", error.message));
  }

  getQuotationFromForm(){
    return new ContactRequestQuotation(
      this.quotationForm.value.description,
      this.quotationForm.value.comment,
      this.setProductList(),
      this.quotationForm.value.baseCurrency,
      this.quotationForm.value.secondCurrency,
      this.quotationForm.value.quotationDate == null ? null : moment(this.quotationForm.value.quotationDate).utc(true),
      this.quotationForm.value.dueDate == null ? null : moment(this.quotationForm.value.dueDate).utc(true),
      this.quotationForm.value.deposit,
      this.quotationForm.value.priceIncludes, 
      this.quotationForm.value.priceNotIncludes);
  }

  getQuotationTemplates(){
    if(this.contactRequestService.contactRequest!.school && this.contactRequestService.contactRequest!.language){
      this.httpService.getTemplatesBySchoolAndLanguage(this.contactRequestService.contactRequest!.school.id!, this.contactRequestService.contactRequest!.language.id).subscribe(res => {
        this.templates = res;
        this.displayTemplateDialog = true;
      });
    }
  }

  setFormValuesFromTemplate(value: any){
    this.selectedTemplate = value;
    this.quotationForm.get("description")!.setValue(this.selectedTemplate!.description);
    this.quotationForm.get("comment")!.setValue(this.selectedTemplate!.comment);
    this.quotationForm.get("products")!.reset();
    this.clearFormArray(this.quotationForm.get("products") as FormArray);
    this.quotationForm.get("baseCurrency")!.setValue(this.selectedTemplate!.baseCurrency);
    this.quotationForm.get("secondCurrency")!.setValue(this.selectedTemplate!.secondCurrency);
    this.quotationForm.get("quotationDate")!.setValue(moment().toDate());
    this.quotationForm.get("dueDate")!.setValue(null);
    this.quotationForm.get("priceIncludes")!.setValue(this.selectedTemplate!.priceIncludes);
    this.quotationForm.get("priceNotIncludes")!.setValue(this.selectedTemplate!.priceNotIncludes);
    let itemArray = this.quotationForm.get("products") as FormArray;
    for(let product of this.selectedTemplate!.products){
      itemArray.push(this.builder.group({
        type: product.productType,
        description: product.description,
        amount: [new Decimal(product.amount), Validators.pattern(/^[.\d]+$/)],
        currency: product.currency,
        activeMenu: false
      }));
    }
    this.displayTemplateDialog = false;
  }

  clearFormArray(formArray: FormArray){
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }

  get productFormArray(){
    let formArray = this.quotationForm.get('products') as FormArray;
    return formArray.controls;
  }

  isHidden(index: number){
    let array = this.productFormArray;
    if(array[index].get('activeMenu')!.value){
      return false;
    }
    return true;
  }
}
